import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import DataContainer from 'Components/UI/DataContainer';
import { KYCOrganismContainer } from 'Components/ComponentLibrary/Organisms/kycOrganism/container';
import useCollectionState from 'Hooks/useCollectionState';

export const KYCOrganism = ({ resource, onKYCFinished }) => {
  const { loading, loadingError, collection } = useCollectionState({
    // If someone tries to render KYCOrganism without the necessary relationship, there's nothing we can do but explode
    link: resource.relationship(fr.relationships.linkToken.name).link('related').url(),
  });

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      component={KYCOrganismContainer}
      componentProps={{
        resource,
        linkTokenResource: collection ? collection.resources().head() : undefined,
        onKYCFinished,
      }}
    />
  );
};

KYCOrganism.defaultProps = {
};

KYCOrganism.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  onKYCFinished: PropTypes.func.isRequired,
};
